export enum CustomerHistoryTableSortProps {
  ID = 'id',
  STORES = 'stores',
  EMAIL = 'customer.email',
  RAITINGS = 'raitings',
  ACTIVE_PRODUCTS = 'activeProducts',
  COUNTRY = 'country,',
  WEBSITE = 'website',
}

export interface CustomersTableHistorySearchProps {
  id?: string,
  raitingsMin?: number;
  raitingsMax?: number;
  stores?: string,
  email?: string,
  activeProducts?: string,
  country?: string,
  website?: string,
}


